<template>
    <div>
        <!-- <breadcrumb :items="breadcrumbs"></breadcrumb> -->
        <v-container fluid>
            <EditGeneticAnimalForm v-if="animalEpdLoad && animalLoad" @form-updated="formUpdated" :action="'update'"
                :animal="animalData" />
        </v-container>
        <!-- <DataLostWarning :dialogI="dataLossWarning" v-if="dataLossWarning" @closeDialog="closeWarningMessage"
            @saveData="closeWarningMessage"></DataLostWarning> -->
    </div>
</template>
<script>
import EditGeneticAnimalForm from "./EPDFormV2.vue" //"./EditGeneticAnimalForm.vue"
//import EPDService from "@/_services/EPDService";
import AnimalService from "@/_services/AnimalService";
import loadingMixin from "@/mixins/LoadingMixin";
import moment from 'moment';

import {
    animalCategories,
    breeds,
    classes,
    farms,
    farmTypes,
    generalInfo,
    species,
    speciesTypes,
    getDropDownDataAnimalIdentification,
    getDropDownDataBirthOrigin,
    getWeightUnit
} from "@/graphql/Animals.gql";

import {
    animalEpd
} from "@/graphql/EPD.gql";

export default {
    apollo: {
        animalToUpdate: {
            query: generalInfo,
            variables() {
                return { id: parseInt(this.$route.params.geneticid) }
            },
            skip() {
                return this.skipQuery
            },
            update: data => data.generalInformation,
            result({ data }) {
                const animal = data.generalInformation;

                if (animal.removalInformation == null) {
                    animal.removalInformation = {};
                }

                if (animal.animalIdentification == null) {
                    animal.animalIdentification = {};
                }

                if (animal.additionalInformation == null) {
                    animal.additionalInformation = {};
                }

                if (animal.birthOrigin == null) {
                    animal.birthOrigin = {};
                }

                if (animal.parentageInformation == null) {
                    animal.parentageInformation = {};
                }

                if (animal.ownerBreedAssociation == null) {
                    animal.ownerBreedAssociation = {};
                }

                if (animal.breedId == null) {
                    animal.breedId = '9999'
                }

                if (animal.removalInformation && !animal.removalInformation.dateOfRemoval) {
                    animal.removalInformation.dateOfRemoval = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                        .toISOString()
                        .substr(0, 10);
                }

                if (animal.animalIdentification.dateOfRegistration) {
                    animal.animalIdentification.dateOfRegistration = moment(animal.animalIdentification.dateOfRegistration).format('YYYY-MM-DD');
                }

                if (animal.removalInformation.processingDate) {
                    animal.removalInformation.processingDate = moment(animal.removalInformation.processingDate).format('YYYY-MM-DD');
                }

                animal.birthOrigin.dateOfBirth = animal.birthOrigin.dateOfBirth ? moment(animal.birthOrigin.dateOfBirth).format('YYYY-MM-DD') : null;
                animal.removalInformation.dateOfRemoval = moment(animal.removalInformation.dateOfRemoval).format('YYYY-MM-DD');
                if (animal.animalIdentification.identificationMethods && (Array.isArray(animal.animalIdentification.identificationMethods))) {
                    animal.animalIdentification.identificationMethods = animal.animalIdentification.identificationMethods.map(el => {
                        el.id = el.identification_method_id
                        return el
                    })
                } else if (animal.animalIdentification.identificationMethods) {
                    animal.animalIdentification.identificationMethods = []
                } else {
                    animal.animalIdentification.identificationMethods = []
                }

                // let t = Object.assign({}, animal); 
                ///let animalDup = {...animal};
                /// animal.animal_id = animalDup.id;

                let animalDup = JSON.parse(JSON.stringify(animal));
                animal.animal_id = animalDup.id;
                //animal.animal_id = animal.id;
                //Object.assign(animal, { animal_id: animal.id });

                const animalIdString = animal.id.toString();
                let animalIdWithPad = animalIdString.padStart(7, '0');
                animalIdWithPad = "ANI" + animalIdWithPad;
                //animal.id = animalIdWithPad;
                animal.animal_number = animalIdWithPad;

                animal.name = animal.animalIdentification?.livestockName
                animal.dob = animal.birthOrigin?.dateOfBirth
                animal.uniqueIdentifier = animal.animalIdentification?.id
                animal.conceptionMethod = animal.birthOrigin?.conceptionMethod?.name

                animal.sireId =  animal.parentageInformation.sireId
                animal.damId =  animal.parentageInformation.damId

                animal.registrationNumber =  animal.animalIdentification?.govRegistrationNo;
                animal.registrationDate =  animal.animalIdentification?.dateOfRegistration;

                animal.weightUnit = this.weightUnit;


                this.animalData = {...this.animalData,...animal};
                this.animalLoad = true;

            }
        },
        getWeightUnit: {
            query: getWeightUnit,
            variables() {
                return { userId: parseInt(this.$store.getters.getUser.id) }
            },
            result(data) {
                this.weightUnit = data.data.getWeightUnit.unit
            }
        },
        animalCategories: {
            query: animalCategories,
        },
        breeds: {
            query: breeds,
        },
        classes: {
            query: classes,
        },
        farms: {
            query: farms
        },
        farmTypes: {
            query: farmTypes,
        },
        species: {
            query: species,
        },
        speciesTypes: {
            query: speciesTypes,
        },
        getDropDownDataAnimalIdentification: {
            query: getDropDownDataAnimalIdentification,
        },
        getDropDownDataBirthOrigin: {
            query: getDropDownDataBirthOrigin,
        },
        animalEpd: {
            query: animalEpd,
            variables() {
                return {
                    animal_id: parseInt(this.$route.params.geneticid),
                        userId: parseInt(this.$store.getters.getUser.id)
                }
            },
            result(data) {
               
                this.animalEpdLoad = true;
                this.animalData.AnimalEpd = data.data.animalEpd
                console.log("---------------------",data.data.animalEpd.source)
                if(data.data.animalEpd.source == "LG CLOUD"){
                    console.log("---------LG CLOUD------------",data.data.animalEpd)
                    this.$apollo.queries.animalToUpdate.skip = false
                    this.$apollo.queries.animalToUpdate.refetch();
                }else if(data.data.animalEpd.source == "LG COMM"){
                    console.log("---------LG COMM------------",data.data.animalEpd)
                    //this.getSingleEPD();
                    this.getSingleAnimalData(data.data.animalEpd.animal_id);
                }
                   
            }
        }
    },
    components: {
        EditGeneticAnimalForm
    },
    beforeRouteLeave(to, from, next) {
        if (this.formChanged) {
            this.promptToRoute = to;
            this.dataLossWarning = true;
            return
        }
        next();
    },
    mounted() {
  
        // if(this.$route.query.page){
        // this.tableOptions.page = Number(this.$route.query.page)
        // }else{
        // this.$router.replace(
        //     {query: { page: this.tableOptions.page}}
        // )
        // }
    },
    data() {
        return {
            skipQuery: true,
            weightUnit:null,
            dataLossWarning: false,
            formChanged: false,
            promptToRoute: null,
            animalData: {},
            animalEpdLoad: null,
            animalLoad: null,
            breadcrumbs: [
                {
                    text: this.$t('dashboard'),
                    disabled: false,
                    to: "/",
                },
                {
                    text: this.$t('Edit Genetics'),
                    disabled: true,
                    to: { name: "Genetics" },
                },
            ],
        }
    },
    methods: {
        formUpdated(st) {
            console.log('ssss', st)
            this.formChanged = st;
        },
        closeWarningMessage(stay) {
            this.dataLossWarning = false;
            if (!stay) {
                this.formChanged = false;
                this.$router.push(this.promptToRoute)
            }
        },
        getSingleAnimalData(animalId) {
            AnimalService.getSingleAnimalById(animalId)
            .then( res => {
                let animal = res.data.animalDetails;
                animal.animal_number = animal.animalNumber;
                animal.animal_id = animal.id;

                if(animal.gender == "male"){
                    animal.gender = "Male";
                }else if(animal.gender == "female"){
                    animal.gender = "Female";
                }
                
                // animal.damId = animal.damId;
                // animal.sireId = animal.sireId;
                this.animalData = {...this.animalData,...animal};
                console.log(this.animalData,"getSingleAnimalDataCOM");

                this.animalLoad = true;
                //console.log(res.data,"res.datares.data")
                //this.animal =res.data;
            })
            .catch(err => {
                console.log(err)
            })
        },
        // getSingleEPD() {
        //     this.startLoading()
        //     EPDService.getSingleEPD(this.$route.params.geneticid)
        //     .then(({data}) => {
        //         if(data.animalRemovalDate == '0000-00-00')
        //             data.animalRemovalDate = ''
        //         this.animalData = data;
        //         this.stopLoading()
        //     })
        //     .catch((err) => {
        //         console.log('err', err)
        //         this.stopLoading()
        //     })
        // }
    },
    mixins: [loadingMixin]
}
</script>